module.exports = __webpack_public_path__ + "img/Trabajo.22cadb28.png";